import WeekHeader from './WeekHeader.view';

export default WeekHeader;
